module.exports = __webpack_public_path__ + "static/gallery_kerry_4_thumb-59d40172fe4060cff784df17dcc8fdbd.jpg";